import ENTechnology from './news-en-technology'
import ENEntertainment from './news-en-entertainment'
import ENHealth from './news-en-health'
import ENScience from './news-en-science'
import ENSports from './news-en-sports'

const ENCategories = {
    technology: ENTechnology,
    entertainment: ENEntertainment,
    health: ENHealth,
    science: ENScience,
    sports: ENSports
}

export default ENCategories;
